import { Component } from '@angular/core';

@Component({
  selector: 'app-schedule-loader',
  templateUrl: './schedule-loader.component.html',
  styleUrls: ['./schedule-loader.component.css']
})
export class ScheduleLoaderComponent {

}
